import { Navigate } from "react-router-dom";
import useAuth from "../../hooks/useAuth"; // Assume useAuth is a hook that provides user authentication status

function PrivateRoute({ children }) {
  const { user } = useAuth();

  if (!user) {
    return <Navigate to="/login" />;
  }

  return children;
}

export default PrivateRoute;
